import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

const PricingUnavailableGuard = () => (
  <Box sx={{ p: 3 }}>
    <Alert severity="error">
      <AlertTitle>Pricing Rules Unavailable</AlertTitle>
      <Typography variant="body2" paragraph>
        This page is not available because your partner account has
        {' '}
        <strong>Use Absolute Values for Pricing</strong>
        {' '}
        enabled. This setting uses a different pricing model that is incompatible with the
        Pricing Rules interface. Condition Discount pricing also requires an active Yerdle Price
        setup to take effect.
      </Typography>
      <Typography variant="body2">
        To use this page, either:
      </Typography>
      <Box component="ul" sx={{ m: 0, mt: 1, pl: 2.5 }}>
        <li>
          <Typography variant="body2">
            Contact your Trove representative to disable the
            {' '}
            <em>Use Absolute Values for Pricing</em>
            {' '}
            setting, or
          </Typography>
        </li>
        <li>
          <Typography variant="body2">
            Use the Trove Admin portal to manage pricing rules instead.
          </Typography>
        </li>
      </Box>
    </Alert>
  </Box>
);

export default PricingUnavailableGuard;
